
import { defineComponent } from "vue";
import { UsersService } from "@/commons/client";
import { Alert } from "@/commons/types";

type Rules = any; // importa il tuo tipo reale se disponibile
type PasswordChangeForm = {
  newPassword: string;
  newPasswordConfirm: string;
};

export default defineComponent({
  name: "PasswordChange",

  components: {
    Alerter: () => import("./Alerter.vue"),
  },

  props: {
    // Consigliato: l’API si aspetta un number
    pk: {
      type: Number,
      required: true,
    },
  },

  data(): {
    alerts: Alert[];
    password1IsClear: boolean;
    password2IsClear: boolean;
    passwordChangeData: PasswordChangeForm;
  } {
    return {
      alerts: [],
      password1IsClear: false,
      password2IsClear: false,
      passwordChangeData: {
        newPassword: "",
        newPasswordConfirm: "",
      },
    };
  },

  computed: {
    rules(): Rules {
      const store = (this as any).$store as { state: { genericRules: Rules } };
      return store?.state?.genericRules ?? {};
    },
    maxCardWidth(): number {
      const bpName =
        // Vuetify 2
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.$vuetify?.breakpoint?.name ??
        // Vuetify 3
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.$vuetify?.display?.name;
      return bpName === "xs" || bpName === "sm" ? 400 : 550;
    },
    isValidData(): boolean {
      const d = this.passwordChangeData;
      return !!(
        d.newPassword &&
        d.newPasswordConfirm &&
        d.newPassword === d.newPasswordConfirm
      );
    },
  },

  methods: {
    async updatePassword(): Promise<void> {
      if (!this.isValidData) {
        this.alerts.push({
          type: "error",
          text: "Le password non coincidono",
        });
        return;
      }

      try {
        await UsersService.userSetPasswordV1UsersPkSetPasswordPatch(
          this.pk, // ora è number certo
          { password: this.passwordChangeData.newPassword }
        );
        this.alerts.push({
          type: "success",
          text: "Password aggiornata con successo",
        });
        this.passwordChangeData.newPassword = "";
        this.passwordChangeData.newPasswordConfirm = "";
        this.password1IsClear = false;
        this.password2IsClear = false;
      } catch (err: unknown) {
        const message =
          (err as any)?.body?.detail ||
          (err as Error)?.message ||
          "Errore durante il cambio password";
        this.alerts.push({
          type: "error",
          text: message,
        });
      }
    },
  },
});
